import React from 'react';

function Team() {
  return (
    <div className="page-content">
      <div className="page-header">
        <h1>Our Legal Team</h1>
        <p>Experienced advocates dedicated to your success</p>
      </div>

      <section className="content-section">
        <div className="team-grid">
          <div className="team-member">
            <div className="member-photo">SE</div>
            <h3>Sarah Edwards</h3>
            <p className="title">Managing Partner | Family Law</p>
            <p>Sarah founded Sol LLP in 2008 with a vision of providing compassionate family law services. With over 18 years of experience, she has helped hundreds of families navigate divorce, custody disputes, and support matters. Sarah is known for her empathetic approach and fierce advocacy in the courtroom.</p>
            <p style={{ marginTop: '15px' }}><strong>Education:</strong> UBC Faculty of Law (J.D., 2006)</p>
          </div>

          <div className="team-member">
            <div className="member-photo">MO</div>
            <h3>Michael O'Connor</h3>
            <p className="title">Senior Partner | Personal Injury</p>
            <p>Michael brings 22 years of trial experience to Sol LLP, specializing in complex personal injury and ICBC claims. He has secured millions in compensation for accident victims throughout BC. Michael's tenacious advocacy and attention to detail have earned him recognition as one of Kelowna's top injury lawyers.</p>
            <p style={{ marginTop: '15px' }}><strong>Education:</strong> University of Victoria Faculty of Law (J.D., 2002)</p>
          </div>

          <div className="team-member">
            <div className="member-photo">JP</div>
            <h3>Jennifer Park</h3>
            <p className="title">Associate Lawyer | Family Law</p>
            <p>Jennifer joined Sol LLP in 2018, bringing fresh perspectives and modern approaches to family law. She focuses on collaborative law solutions and mediation, helping clients resolve disputes efficiently. Her bilingual abilities (English/Korean) serve our diverse community well.</p>
            <p style={{ marginTop: '15px' }}><strong>Education:</strong> Queen's University Faculty of Law (J.D., 2016)</p>
          </div>

          <div className="team-member">
            <div className="member-photo">DT</div>
            <h3>David Thompson</h3>
            <p className="title">Associate Lawyer | Personal Injury</p>
            <p>David focuses exclusively on personal injury claims, including motor vehicle accidents, slip and falls, and workplace injuries. Since joining Sol LLP in 2020, he has successfully handled over 150 ICBC claims. David is passionate about holding negligent parties accountable and fighting for full compensation.</p>
            <p style={{ marginTop: '15px' }}><strong>Education:</strong> Western University Faculty of Law (J.D., 2018)</p>
          </div>
        </div>

        <div className="text-content" style={{ marginTop: '60px', textAlign: 'center' }}>
          <h3>Supporting Team</h3>
          <p>Our lawyers are supported by a dedicated team of paralegals, legal assistants, and administrative professionals who ensure your case receives meticulous attention at every stage.</p>
        </div>
      </section>
    </div>
  );
}

export default Team;

